var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuIcon02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.98504 7.39566C7.83224 7.46202 7.66743 7.49626 7.50084 7.49626C7.33425 7.49626 7.16944 7.46202 7.01663 7.39566L1.14438 4.67588C1.04903 4.62779 0.968892 4.55417 0.912904 4.46322C0.856915 4.37227 0.827271 4.26757 0.827271 4.16077C0.827271 4.05398 0.856915 3.94927 0.912904 3.85833C0.968892 3.76738 1.04903 3.69376 1.14438 3.64566L7.01663 0.90528C7.16944 0.838927 7.33425 0.804687 7.50084 0.804688C7.66743 0.804688 7.83224 0.838927 7.98504 0.90528L13.8573 3.62506C13.9527 3.67316 14.0328 3.74678 14.0888 3.83772C14.1448 3.92867 14.1744 4.03337 14.1744 4.14017C14.1744 4.24697 14.1448 4.35167 14.0888 4.44262C14.0328 4.53356 13.9527 4.60718 13.8573 4.65528L7.98504 7.39566Z",
    fill: "#C8C8C8",
    stroke: "#212B36",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1964 7.85938L7.91211 10.7543C7.77789 10.8155 7.63209 10.8472 7.48456 10.8472C7.33704 10.8472 7.19124 10.8155 7.05702 10.7543L0.803589 7.85938",
    stroke: "#212B36",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1964 11.2075L7.91211 14.1024C7.77789 14.1637 7.63209 14.1953 7.48456 14.1953C7.33704 14.1953 7.19124 14.1637 7.05702 14.1024L0.803589 11.2075",
    stroke: "#212B36",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon02);
export default __webpack_public_path__ + "static/media/menu-icon-02.a431db191b8e1dd7ad584180d1a1b8a0.svg";
export { ForwardRef as ReactComponent };